import { authorizedFetch as fetchGET, fetchDELETE, fetchPUT, fetchPOST } from '@/helpers/authFetch';
import checkedFetch from '@/utils/fetchers';
import { notificationsEndPoint, checkServiceOK } from './serviceConstants';

function sortNotifications(notification) {
  return notification.sort((a, b) => (a.creationDate < b.creationDate ? 1 : -1));
}

async function getRecentNotifications() {
  const notifications = await checkedFetch(`${notificationsEndPoint}/bells`, { bells: [] });

  return sortNotifications(notifications?.bells || []);
}

async function getAllNotifications() {
  const notifications = await checkedFetch(`${notificationsEndPoint}/bells/older`, { bells: [] });

  return sortNotifications(notifications?.bells || []);
}

async function getCounterNotifications() {
  const bellsCountInfo = await checkedFetch(`${notificationsEndPoint}/bells/counter`, { bellsCount: 0, thereAreOldNotifications: false });

  return bellsCountInfo;
}

const updateBells = (bellId) => (
  fetchPUT(`${notificationsEndPoint}/bells/${bellId}/mark-as-read`).then((res) => checkServiceOK(res, true))
);

async function markAsReadAll() {
  const notifications = await fetchPUT(`${notificationsEndPoint}/bells/mark-all-as-read`, { bells: [] }).then((res) => checkServiceOK(res, false));

  return sortNotifications(notifications?.bells || []);
}

async function removeBells(bellId) {
  const path = bellId ? `bells/user/${bellId}` : 'bells/user';

  return fetchDELETE(`${notificationsEndPoint}${path}`).then((res) => checkServiceOK(res, true));
}

async function getEmailTemplates() {
  return fetchGET(`${notificationsEndPoint}/email-templates`).then((res) => checkServiceOK(res));
}

async function createEmailTemplate(email) {
  return fetchPOST(`${notificationsEndPoint}/email-templates`, email).then((res) => checkServiceOK(res, true));
}

async function createCopyEmailTemplate(id) {
  return fetchPOST(`${notificationsEndPoint}/email-templates/${id}/copy`).then((res) => checkServiceOK(res, true));
}

async function getEmailDetails(id) {
  return fetchGET(`${notificationsEndPoint}/email-templates/${id}`).then((res) => checkServiceOK(res));
}

async function removeEmail(id) {
  return fetchDELETE(`${notificationsEndPoint}/email-templates/${id}`).then((res) => checkServiceOK(res, true));
}

async function saveEmailDetails(id, email) {
  return fetchPUT(`${notificationsEndPoint}/email-templates/${id}`, email).then((res) => checkServiceOK(res, true));
}

async function getEmailWorkflows() {
  return fetchGET(`${notificationsEndPoint}/email-rules`).then((res) => checkServiceOK(res));
}

async function getEmailWorkflowsFormOptions() {
  return fetchGET(`${notificationsEndPoint}/email-rules/forms`).then((res) => checkServiceOK(res));
}

async function getEmailVariables() {
  return fetchGET(`${notificationsEndPoint}/email-variables`).then((res) => checkServiceOK(res));
}

async function deleteEmailWorkflow(id) {
  return fetchDELETE(`${notificationsEndPoint}/email-rules/${id}`).then((res) => checkServiceOK(res, true));
}

async function createCopyOfEmailWorkflow(id) {
  return fetchPOST(`${notificationsEndPoint}/email-rules/${id}/copy`).then((res) => checkServiceOK(res, true));
}

async function updateEmailWorkflow(id, emailWorkflow) {
  return fetchPUT(`${notificationsEndPoint}/email-rules/${id}`, emailWorkflow).then((res) => checkServiceOK(res, true));
}

async function createEmailWorkflow(emailWorkflow) {
  return fetchPOST(`${notificationsEndPoint}/email-rules`, emailWorkflow).then((res) => checkServiceOK(res, true));
}

const notificationsService = {
  getRecentNotifications,
  getAllNotifications,
  getCounterNotifications,
  updateBells,
  markAsReadAll,
  removeBells,
  getEmailWorkflows,
  getEmailWorkflowsFormOptions,
  getEmailTemplates,
  createEmailTemplate,
  createCopyEmailTemplate,
  getEmailDetails,
  saveEmailDetails,
  getEmailVariables,
  removeEmail,
  deleteEmailWorkflow,
  createCopyOfEmailWorkflow,
  updateEmailWorkflow,
  createEmailWorkflow,
};

export default notificationsService;
